import { memo, useCallback, useMemo } from 'react';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { useAdditionalPropertyValues } from '../v2/hooks/useAdditionalPropertyValues';
import { formatPeriodText, getMonthsPerPeriod, getPeriodFromMonths, getPeriodFromWeeks, getWeeksPerPeriod, isWeeklyOrBiweeklyBillingFrequency } from '../v2/utils/period';
import { usePropertyValue } from '../v2/hooks/usePropertyValue';
import { useIsFocused } from '../v2/hooks/useIsFocused';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import NumberInputAdapter from '../adapters/NumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputBillingPeriod = props => {
  const {
    onChange,
    inputRef
  } = props;
  const isFocused = useIsFocused();
  const periodValue = usePropertyValue();
  const {
    data: additionalValues
  } = useAdditionalPropertyValues({
    recurringBillingFrequency: 'recurringbillingfrequency'
  });
  useComponentMountMetric('PropertyInputBillingPeriod');
  const recurringBillingFrequency = additionalValues === null || additionalValues === void 0 ? void 0 : additionalValues.recurringBillingFrequency;
  const isWeeklyOrBiweeklyFrequency = isWeeklyOrBiweeklyBillingFrequency(recurringBillingFrequency);
  const handleChange = useCallback(({
    target: {
      value: newValue
    }
  }) => {
    let newPeriodValue = '';
    if (isWeeklyOrBiweeklyFrequency) {
      newPeriodValue = getPeriodFromWeeks(newValue);
    } else {
      newPeriodValue = getPeriodFromMonths(newValue);
    }
    onChange(syntheticEvent(newPeriodValue));
  }, [isWeeklyOrBiweeklyFrequency, onChange]);
  const parsedPeriodValue = isWeeklyOrBiweeklyFrequency ? getWeeksPerPeriod(periodValue) : getMonthsPerPeriod(periodValue);
  const formatter = useMemo(() => {
    if (!recurringBillingFrequency) {
      return undefined;
    }
    return period => {
      if (period == null) {
        return '';
      }
      return isFocused ? String(period) : formatPeriodText(period, recurringBillingFrequency);
    };
  }, [isFocused, recurringBillingFrequency]);
  return /*#__PURE__*/_jsx(NumberInputAdapter, Object.assign({}, getTransferrableProps(props), {
    min: 0,
    formatter: formatter,
    onChange: handleChange,
    inputRef: inputRef
    // @ts-expect-error UINumberInput propTypes allow 'null', but TS types do not; see https://git.hubteam.com/HubSpot/UIComponents/issues/10822
    ,
    value: parsedPeriodValue
  }));
};
export default /*#__PURE__*/memo(PropertyInputBillingPeriod);